import * as React from 'react';
import { motion, useInView } from 'framer-motion';
import ImageCarousel from './ImageCarousel';

const AboutStory: React.FC = () => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });

  const fadeInUp = {
    hidden: { opacity: 0, y: 60 },
    visible: { opacity: 1, y: 0 },
    transition: { duration: 0.5 }
    };

  const stagger = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.5
      }
    }
  };

  return (
    <motion.section 
      ref={ref}
      className="py-16 px-4 lg:px-10"
      variants={stagger}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
    >
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <motion.div variants={fadeInUp}>
            <div className="space-y-4 text-lg leading-relaxed">
              <p>
                O Schique surgiu da paixão pela beleza e do desejo de oferecer um ambiente onde cada cliente se sinta especial e único.
              </p>
              <p>
              Conta com uma equipa qualificada e em constante formação, que usa técnicas avançadas e produtos de alta qualidade para garantir ótimos resultados.
              </p>
              <p>
                Acreditamos que a beleza é uma forma de expressão pessoal, e comprometemo-nos em ajudar cada cliente a descobrir e realçar a sua beleza natural.
              </p>
            </div>
          </motion.div>

          {/* Image Placeholder */}
          <motion.div 
            className="relative"
            variants={fadeInUp}
          >
            <ImageCarousel /> 
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};

export default AboutStory; 